export default __webpack_public_path__ + "static/media/echo.60b77b4b.png";